/**
 * LEGRO desktop overlay stacking contract (R79).
 *
 * Prefer portaling overlays to document.body (appendTo / getPopupContainer)
 * instead of inventing one-off z-index:999999 values.
 *
 * Tiers (lowest → highest):
 * - base content
 * - sticky / header chrome
 * - modal / dialog shell (Prime default ~1100)
 * - dropdown / select panels (must clear dialog content)
 * - popover
 * - mention / editor suggestion
 * - toast
 */

export const OVERLAY_Z = Object.freeze({
  base: 1,
  sticky: 100,
  /** PrimeReact Dialog / mask band */
  modal: 1100,
  /** Select / MultiSelect / Dropdown panels portaled to body */
  dropdown: 1200,
  popover: 1300,
  /** Quill @mention list (fixed positioning) */
  mention: 1250,
  toast: 11000,
});

export const OVERLAY_PANEL_CLASS = 'maf-overlay-panel';
export const OVERLAY_NATIVE_SELECT_CLASS = 'maf-native-select';
export const OVERLAY_MENTION_CONTAINER_CLASS = 'ql-mention-list-container maf-mention-overlay';

/** Shared Prime overlay props for Dropdown / MultiSelect / Calendar panels. */
export function primeOverlayPanelProps(extra = {}) {
  const appendTo =
    typeof document !== 'undefined' ? document.body : null;
  return {
    appendTo,
    panelClassName: [OVERLAY_PANEL_CLASS, extra.panelClassName].filter(Boolean).join(' '),
    panelStyle: {
      zIndex: OVERLAY_Z.dropdown,
      ...(extra.panelStyle || {}),
    },
  };
}

/** Ant Design Select / Cascader popup contract. */
export function antdPopupOverlayProps(extra = {}) {
  return {
    getPopupContainer: (typeof document !== 'undefined'
      ? () => document.body
      : undefined),
    dropdownStyle: {
      zIndex: OVERLAY_Z.dropdown,
      ...(extra.dropdownStyle || {}),
    },
  };
}

/** quill-mention module extras (merge into modules.mention). */
export function quillMentionOverlayOptions() {
  return {
    positioningStrategy: 'fixed',
    defaultMenuOrientation: 'bottom',
    mentionContainerClass: OVERLAY_MENTION_CONTAINER_CLASS,
  };
}
